// extracted by mini-css-extract-plugin
export var actions = "_4v-0";
export var actionsContainer = "_4v-7";
export var border = "_4v-1";
export var childFullHeight = "_4v-f";
export var collapse = "_4v-2";
export var content = "_4v-a";
export var contentChild = "_4v-e";
export var fullscreen = "_4v-c";
export var hasLeftRadius = "_4v-k";
export var headerContainer = "_4v-3";
export var headerRow = "_4v-5";
export var hidePadding = "_4v-b";
export var navCollapsedGap = "_4v-l";
export var noScrollX = "_4v-m";
export var noScrollY = "_4v-n";
export var noTopPadding = "_4v-i";
export var optOutTopPadding = "_4v-d";
export var pageMain = "_4v-j";
export var pageOuter = "_4v-g";
export var pagePadding = "_4v-8";
export var pageScroll = "_4v-9";
export var profile = "_4v-o";
export var profileContainer = "_4v-p";
export var profileImage = "_4v-q";
export var profileMain = "_4v-r";
export var profileSubtitle = "_4v-t";
export var profileTitle = "_4v-s";
export var showLeftPadding = "_4v-h";
export var tabsPortalSlot = "_4v-6";
export var tabsWrapper = "_4v-4";
export var title = "_4v-u";